export const SEND_FORM = 'SEND_FORM'
export const SET_LOADING = 'SET_LOADING'
